/**
 *
 */
function UserAgent() {}

/**
 * 苹果
 * @returns
 */
UserAgent.isIOS = function () {
  const ua = typeof window === 'object' ? window.navigator.userAgent : ''
  return /iPhone|iPod|iPad|iOS/i.test(ua)
}

/**
 * 安卓
 * @returns
 */
UserAgent.isAndroid = function () {
  const ua = typeof window === 'object' ? window.navigator.userAgent : ''
  return /Android/i.test(ua)
}

/**
 * 微信端
 * @returns
 */
UserAgent.isWechat = function () {
  const ua = typeof window === 'object' ? window.navigator.userAgent : ''
  return /MicroMessenger/i.test(ua)
}

/**
 * 微信小程序
 * @returns
 */
UserAgent.isWechatMiniProgram = function () {
  const ua = typeof window === 'object' ? window.navigator.userAgent : ''
  return /miniprogram/i.test(ua.toLowerCase())
}

/**
 * 微信浏览器端
 * @returns
 */
UserAgent.isWechatBrowser = function () {
  return UserAgent.isWechat() && !UserAgent.isWechatMiniProgram()
}

/**
 * tiny app
 * @returns
 */
UserAgent.isTiny = function () {
  // eslint-disable-next-line no-undef
  return typeof Tiny !== 'undefined' && typeof Tiny.execute === 'function'
}

/**
 * 苹果app
 * @returns
 */
UserAgent.isIOSTiny = function () {
  return UserAgent.isTiny() && UserAgent.isIOS()
}

/**
 * 安卓app
 * @returns
 */
UserAgent.isAndroidTiny = function () {
  return UserAgent.isTiny() && UserAgent.isAndroid()
}

/**
 * 移动端浏览器
 * @param {*} params
 */
UserAgent.mobileAgent = function () {
  let userAgent = window.navigator.userAgent.toLowerCase()
  return /mobi/i.test(userAgent)
}

// 旧版本的IE（IE11及以下）
UserAgent.isOldIE = function () {
  var ua = window.navigator.userAgent
  return /MSIE|Trident/.test(ua)
}

export default UserAgent



// WEBPACK FOOTER //
// ./src/utils/user-agent.js